import {request,downRequest} from "@/utils/request";
/**
 * 开始任务
 */
export function _pdf_pre_check(data) {
    return request({
        url: "/saas_clear_bid/similar/pdf_pre_check",
        method: "POST",
        data,
    });
}

export function send_qw(data) {
    return request({
        url: "/bst_behavior/bst/bst/send_qw",
        method: "POST",
        data,
    });
}
// http://112.zhulong.com.cn:8103/bswjjc/pdf/similar/get_org_sim_info
// http://112.zhulong.com.cn:8103/bst_saas_clear_bid/similar/get_pic_sim_pic
export function getPicSimPic(data) {
    return request({
        url: "/bswjjc/pdf/similar/get_pic_sim_pic",
        method: "get",
        params: data
    });
}
//https://abc.zhulong.com.cn/bswjjc/pdf/similar/get_org_sim_info/
// /similar/result_by_org_new
export function resultByOrgNew(data) {
    return request({
        url: "/bswjjc/pdf/similar/result_by_org_new",
        method: "get",
        params: data
    });
}
// http://112.zhulong.com.cn:8103/bst_saas_clear_bid/similar/get_org_sim_info
export function getOrgSimInfo(data) {
    return request({
        url: "/bswjjc/pdf/similar/get_org_sim_info",
        method: "get",
        params: data
    });
}
/**
 * 开始任务
 */
export function pdf_pre_check(data) {
    return request({
        url: "/bswjjc/pdf/similar/pdf_pre_check",
        method: "POST",
        data,
    });
}
// /pdf/similar/getDemoProjectId

export function getDemoProjectId(data){
    return request({
        url: "/bswjjc/pdf/similar/getDemoProjectId",
        method: "get",
        params:data
    });
}
/**
 * 查询任务进度
 */
export function _getStatus(data){
    return request({
        url: "/saas_clear_bid/similar/fe_process_status",
        method: "get",
        params:data
    });
}

export function getStatus(data){
    return request({
        url: "/bswjjc/pdf/similar/process_status",
        method: "get",
        params:data
    });
}



/**
 * 获取检查的目录节点
 */
export function _getCatelogue(data){
    return request({
        url: "/saas_clear_bid/similar/get_catalogue",
        method: "get",
        params: data
    })
}
export function getCatelogue(data){
    return request({
        url: "/bswjjc/pdf/similar/get_catalogue",
        method: "get",
        params: data
    })
}
/**
 * 获取任务评估信息
 */
export function _getEvaluation(data){
    return request({
        url:"/saas_clear_bid/similar/get_evaluation",
        method:"get",
        params:data
    })
}

export function getEvaluation(data){
    return request({
        url:"/bswjjc/pdf/similar/get_evaluation",
        method:"get",
        params:data
    })
}
/**
 * 获取已有的单位列表
 */
export function _getCompanyList( data) {
    return request({
        url: `/saas_clear_bid/similar/project_orgs`,
        method: "get",
        params: data
    })
}

export function getCompanyList( data) {
    return request({
        url: `/bswjjc/pdf/similar/project_orgs`,
        method: "get",
        params: data
    })
}


/**
 * 根据单位名 取该单位的相似结果
 */
export function _getCompanyDataByName( data) {
    return request({
        url: `/saas_clear_bid/similar/result_by_org`,
        method: "get",
        params: data
    })
}
export function getCompanyDataByName( data) {
    return request({
        url: `/bswjjc/pdf/similar/result_by_org`,
        method: "get",
        params: data
    })
}


/**
 *
 * 获取文件图片
 */
export function _getPdfDataImg(data){
    return request({
        url: `/saas_clear_bid/similar/get_pdf_page`,
        method: "get",
        params: data
    })
}

export function getPdfDataImg(data){
    return request({
        url: `/bswjjc/pdf/similar/get_pdf_page`,
        method: "get",
        params: data
    })
}


/**
 * 获取相似图片
 * @param data
 * @returns {AxiosPromise}
 */
export function getSimilarPic(data){
    return request({
        url: `/bswjjc/pdf/similar/get_pic_sim_pic`,
        method: "get",
        params: data
    })
}

/**
 * 获取以单位为维度的相似统计数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getOrgSim(data){
    return request({
        url: `/bswjjc/pdf/similar/get_org_sim_info`,
        method: "get",
        params: data
    })
}



export function getHistory_pdf(data){
    return request({
        url: `/saas_clear_bid/similar/get_history`,
        method: "get",
        params: data
    })
}

export function delHistory_pdf(data){
    return request({
        url: `/saas_clear_bid/similar/remove_record`,
        method:"get",
        params:data
    })
}

export function getPdf_content(data){
    return request({
        url: `/saas_clear_bid/similar/project_content`,
        method:"get",
        params:data
    })

}

export function exportFile(data){
    return downRequest({
        url: `/saas_clear_bid/similar/export_result`,
        method: "get",
        params: data
    })
}

/**
 *
 * 取消任务
 */
export function _revoke_task(data){
    return request({
        url: `/saas_clear_bid/similar/revoke_task`,
        method:"get",
        params:data
    })
}

export function revoke_task(data){
    return request({
        url: `/bswjjc/pdf/similar/revoke_task`,
        method:"get",
        params:data
    })
}
// http://112.zhulong.com.cn:8103/bswjjc/project-info/latest-running-project

export function latestRunningProject(data){
    return request({
        url: `/bswjjc/project-info/latest-running-project`,
        method:"get",
        params:data
    })
}